import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRotateLeftRight"><Path fillRule="evenodd" clipRule="evenodd" d="M5.5 3V5.71122C7.1554 4.03743 9.4791 3 12 3C16.9706 3 21 7.02944 21 12V12.75H19.5V12C19.5 7.85786 16.1421 4.5 12 4.5C9.77612 4.5 7.73561 5.46681 6.3448 7H9.5V8.5H4V3H5.5ZM4.5 11.25V12C4.5 16.1421 7.85786 19.5 12 19.5C14.2239 19.5 16.2644 18.5332 17.6552 17H14.5118V15.5H20.0118V21H18.5118V18.2768C16.8557 19.9576 14.5269 21 12 21C7.02944 21 3 16.9706 3 12V11.25H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRotateLeftRight;
